<div class="tds-cnt" (click)="mouseupHandler($event)">
    <!-- TOOLBAR CNT -->
    <div class="cnt-toolbar">
        <teiasoft-toolbar [buttonsList]="buttonsList" [theme]="globals.theme!"
            (onBtnClick)="onMenuBtnToolbarClick($event)" style="width: 100%;"></teiasoft-toolbar>
    </div>
    <!-- GRID CONTAINER -->
    <div *ngIf="isLoaded" class="tds-grid" (scroll)="onScrolling()">
        <!-- HEADER -->
        <div class="tds-header" [style.width.px]="rowWidth">
            <div class="tds-cell-checkbox ">
                <input type="checkbox" (click)="onSelectAll($event)"
                    [checked]="getVisibleSelectedCount() > 0 && getVisibleSelectedCount() == getVisibleRowCount()"
                    [indeterminate]="getVisibleSelectedCount() > 0  && getVisibleSelectedCount() < getVisibleRowCount()"
                    id="chkAll">
            </div>
            <!-- , 'cell-fixed-h' : i == 0,  -->
            <div *ngFor="let item of dataSheet; let i=index; trackBy: trackByIndex" class="tds-cell border border-left"
                resizableColumn [columnName]="item.colName!" (onColumnWidthUpdate)="onColumnWidthUpdate($event)"
                [shouldRecalculate]="recalculateColumnsWidth" (onResizeEnd)="onColumnResizeEnd()"
                [gridConfiguration]="gridConfiguration" [resizingFlag]="resizingFlag"
                [ngStyle]="{'display':  item.isHidden? 'none': 'flex'}" [class.sticky-column]="isFrozenColumn(i)"
                [style.left.px]="getStickyLeftPosition(i)">
                <div *ngIf="!item.isHidden" class="tds-header-cell-content">
                    <span class="span-header">{{getColumnHeaderName(item.colName)}}
                        <span *ngIf="item.isRequired">*</span></span>
                </div>
                <!-- <i *ngIf="item.colEditable && mapSelected && mapSelected.length > 0" class="fal fa-edit ico-header mr-5" ></i> -->
                <!-- <i *ngIf="item.colEditable && (!mapSelected || mapSelected.length == 0) && item.colName!.toLowerCase() == 'normgrades'" class="fal fa-edit ico-disabled mr-5"></i> -->
                <!-- <i *ngIf="isColInEdit(i) && item.colName!.toLowerCase() == 'normgrades'"
                    class="fas fa-check-square ico-header mr-5" style="color:#ff6600" (click)="closeEdit()"></i> -->
            </div>
        </div>

        <!-- FILTER -->
        <div class="tds-filter tds-row" [style.display]="gridFilterable?  '' : 'none'" [style.width.px]="rowWidth">
            <!-- Checkbox Column (empty) -->
            <div class="tds-cell-checkbox" style="height: 8vh !important;">
                <input type="checkbox" style="visibility: hidden;">
            </div>

            <!-- Columns Filters -->
            <div *ngFor="let col of dataSheet; let c = index" class="tds-filter-cell"
                [class.sticky-column]="isFrozenColumn(c)" [style.left.px]="getStickyLeftPosition(c)"
                [ngStyle]="{'display':  col.isHidden? 'none': 'inherit'}"
                [style.width.px]="getColumnWidth(col.colName!)">
                <div class="tds-filter-cell-input">
                    <teiasoft-input *ngIf="col.colType == 'number' || col.colType == 'string' || col.colType == 'date'"
                        [size]="'s'" (onInput)="onFilterInputChange($event, col!)"
                        [labelText]="'grid.contains' | translate" style="width: 100%;" [type]="col.colType!"
                        [isMultiOperator]="col.colType == 'number'" [disabled]="mapSelected.length > 0"
                        [value]="getFilterValue(col.colName!,col.colType!)">
                    </teiasoft-input>
                    <teiasoft-select *ngIf="col.colType == 'boolean'" [size]="'s'" [optionsList]="booleanColumnsOptions"
                        [filterVersion]="true" [labelText]="'grid.equals' | translate" style="width: 100%"
                        [disabled]="mapSelected.length > 0" [defaultValue]="getFilterValue(col.colName!,col.colType!)"
                        (onSelected)="onFilterInputChange($event.value, col!)">
                    </teiasoft-select>

                    <teiasoft-select-options *ngIf="col.colType == 'object' || col.colType == 'select'"
                        [disabled]="mapSelected.length > 0" [inputValues]="filtersValues" [colName]="col.colName!"
                        (onSelectedFilterOptions)="onSelectedFilterOptions($event,col)"
                        [oDataFilterMaps]="filterMaps"></teiasoft-select-options>
                </div>

            </div>
        </div>

        <!-- DATA -->
        <div class="tds-row" [style.width.px]="rowWidth">
            <div
                style="display: flex;flex-direction: column;align-items: center;justify-content: flex-start;background-color: #fff;z-index:99">
                <div *ngIf="dataSheet && dataSheet.length > 0">
                    <div *ngFor="let cc of dataSheet[0].colValue; let p=index; trackBy: trackByIndex"
                        class="tds-cell-checkbox" (click)="onSelectRow($event, p)"
                        [ngClass]="{'row-selected' : getIfImChecked(p), 'row-disabled' : isSelectionCheckboxDisabled(p),'border-top' : p > 0,'invisible': !filteredRowIndices.includes(p)}"
                        #checkboxContainer>
                        <input type="checkbox" class="tds-checkbox" [checked]="getIfImChecked(p)"
                            [disabled]="isSelectionCheckboxDisabled(p)">
                    </div>
                </div>
            </div>
            <div *ngFor="let col of dataSheet; let x=index; trackBy: trackByIndex" class="tds-cnt-value"
                [ngStyle]="{'display':  col.isHidden? 'none': 'inherit'}" [class.sticky-column]="isFrozenColumn(x)"
                [style.left.px]="getStickyLeftPosition(x)">
                <div *ngFor="let val of col.colValue; let c=index; trackBy: trackByIndex" class="tds-cell" [ngClass]="{
                    'border-left' : true, 'border-top' : c > 0, 'cell-selected' : selectedCell(c, x),
                                        'row-selected' : getIfImChecked(c), 'row-disabled' : mapSelected.length > 0 && !getIfImChecked(c), 'cell-error': isCellInError(c,x, col.colName!) && !isInEdit(c,x),
                                        'cell-disabled': !isCellInError(c,x, col.colName!) && isToDisable(c,x,col.colName!),
                                        'ready-to-delete' : isInDelete(c),
                                        'invisible': !filteredRowIndices.includes(c)}"
                    [matTooltip]="'errors.fieldNotEditable' | translate"
                    [matTooltipDisabled]="!(!isCellInError(c,x, col.colName!) && isToDisable(c,x,col.colName!))"
                    (click)="!isToDisable(c,x,col.colName!) && makeMeEditable(c,x, col.colName!, col.colValue![c], col.colType!, $event)"
                    [tabindex]="c" [attr.data-row]="c" [attr.data-col]="x" (keydown)="handleKeydown($event, c, x)">

                    <!-- NOT IN EDIT -->
                    <ng-container *ngIf="!isInEdit(c,x)">
                        <!-- ERROR WARNING -->
                        <i *ngIf="isCellInError(c,x, col.colName!) " class="fas fa-triangle-exclamation ico-error"
                            #tooltip="matTooltip" [matTooltip]="getTooltipText(c,x, col.colName!)"
                            matTooltipPosition="below" matTooltipHideDelay="50"></i>

                        <!-- LOCK INDICATION && -->
                        <i *ngIf="!isCellInError(c,x, col.colName!)  && isToLock(c,x,col.colName!)"
                            class="fal fa-lock ico-lock" [matTooltip]="getLockTooltip(c,x,col.colName!)"></i>
                        <i *ngIf="isCellInError(c,x, col.colName!)  && isToLock(c,x,col.colName!)"
                            class="fas fa-lock ico-lock color-white"
                            [matTooltip]="getLockTooltip(c,x,col.colName!)"></i>

                        <!-- NOT IN EDIT  -->
                        <span [matTooltip]="getValue(val,c, col.colName!)"
                            *ngIf=" (col.colType == 'string' || col.colType == 'number' || col.colType == 'date')"
                            class="span-value 1"
                            [ngClass]="{'italic': col.colName!.toLowerCase() == 'itemno' && val && val.includes('New')}">{{getValue(val,
                            c, col.colName!)}}</span>
                        <span class="span-value 1" *ngIf=" col.colType == 'boolean'">{{getBooleanValue(val,
                            c, col.colName!)}}</span>

                        <span [matTooltip]="getObjectValue(col.colName!, val)"
                            *ngIf=" (col.colType == 'object' || col.colType == 'select') && col.colName != 'NormGrades'"
                            class="span-value 2">{{getObjectValue(col.colName!, val)}}</span>
                        <span [matTooltip]="getObjectValues(col.colName!, val).join(', ')"
                            *ngIf=" (col.colType == 'object' || col.colType == 'select') && col.colName == 'NormGrades'"
                            class="span-value 2">{{getObjectValues(col.colName!, val)}}</span>
                    </ng-container>

                    <!-- IN EDIT -->
                    <ng-container *ngIf="isInEdit(c,x)">

                        <!-- STRING -->
                        <teiasoft-confirmable-input (navigationKey)="handleKeydown($event, c, x)"
                            *ngIf=" (col.colType == 'string' || col.colType == 'number') && col.colName!.toLowerCase() != 'npsschedule' &&  col.colName!.toLowerCase() != 'customerdeliverydate' && col.colName!.toLowerCase() != 'gradecustomeranalysislimitation'"
                            [type]="(col.colType == 'string' ? 'input' : 'inputnumeric')" [applyChange]="applyChange"
                            [value]="getInputValue(col.colName?.toLowerCase(),val)"
                            (confirmChange)="onFocusOut($event, c, x, col.colName!)"
                            (onValueChanged)="onValueChanged($event)"
                            [startIcon]="getInputIcon(col.colName?.toLowerCase())"
                            [allowNegative]="isNegativeNumberAllowed(col.colName?.toLowerCase())"
                            [roundDigits]="getRoundDigits(c,col.colName!)"
                            [maxLength]="col.colName!.toLowerCase() == 'customeritemno' ? 5 : 524288">
                        </teiasoft-confirmable-input>

                        <!-- alloySurcharge -->
                        <teiasoft-confirmable-input (navigationKey)="handleKeydown($event, c, x)"
                            *ngIf="col.colType == 'boolean' && col.colName!.toLowerCase() == 'alloysurcharge'"
                            [type]="'select'" [options]="booleanList" [value]="col.colValue![c]" class="ts-option-row"
                            [applyChange]="applyChange"
                            (confirmChange)="onSelected($event, c, x, col.colType!, col.colName!)"
                            (onValueChanged)="onValueChanged($event)">
                        </teiasoft-confirmable-input>

                        <!-- energySurcharge -->
                        <teiasoft-confirmable-input (navigationKey)="handleKeydown($event, c, x)"
                            *ngIf="col.colType == 'boolean' && col.colName!.toLowerCase() == 'energysurcharge'"
                            [type]="'select'" [options]="booleanList" [value]="col.colValue![c]" class="ts-option-row"
                            [applyChange]="applyChange"
                            (confirmChange)="onSelected($event, c, x, col.colType!, col.colName!)"
                            (onValueChanged)="onValueChanged($event)">
                        </teiasoft-confirmable-input>

                        <!-- uBent -->
                        <teiasoft-confirmable-input (navigationKey)="handleKeydown($event, c, x)"
                            *ngIf="col.colType == 'boolean' && col.colName!.toLowerCase() == 'ubent'" [type]="'select'"
                            [options]="booleanList" [value]="col.colValue![c]" class="ts-option-row"
                            [applyChange]="applyChange"
                            (confirmChange)="onSelected($event, c, x, col.colType!, col.colName!)"
                            (onValueChanged)="onValueChanged($event)">
                        </teiasoft-confirmable-input>

                        <!-- multipleLength -->
                        <teiasoft-confirmable-input (navigationKey)="handleKeydown($event, c, x)"
                            *ngIf="col.colType == 'boolean' && col.colName!.toLowerCase() == 'multiplelength'"
                            [type]="'select'" [options]="booleanList" [value]="col.colValue![c]" class="ts-option-row"
                            [applyChange]="applyChange"
                            (confirmChange)="onSelected($event, c, x, col.colType!, col.colName!)"
                            (onValueChanged)="onValueChanged($event)">
                        </teiasoft-confirmable-input>

                        <!-- unitSytem -->
                        <teiasoft-confirmable-input (navigationKey)="handleKeydown($event, c, x)"
                            *ngIf="col.colType == 'select' && col.colName!.toLowerCase() == 'unitsystem'"
                            [type]="'select'" [options]="unitSystemOptionList" [value]="col.colValue![c]"
                            [applyChange]="applyChange"
                            (confirmChange)="onSelected($event, c, x, col.colType!, col.colName!)"
                            (onValueChanged)="onValueChanged($event)">
                        </teiasoft-confirmable-input>

                        <!-- normGrades -->
                        <div class="confirm-container"
                            *ngIf="col.colType == 'object' && col.colName!.toLowerCase() == 'normgrades'"
                            style="justify-content: space-between;" [tabindex]="c"
                            (keydown)="onConfirmKeyDown($event,c,x,col.colName!)">
                            <!-- normGrades -->
                            <teiasoft-input style="margin-top: -3.8vh;margin-left: 1%;height: 4vh;"
                                [style.width.%]="(valueChanged == true ? 85 : 96)" [type]="'text'" [isMobile]="isMobile"
                                [value]="getObjectValues(col.colName!, val)" [showCreate]="false" [autoComplete]="true"
                                [autoCompleteDataset]="normGradesDataset" [autoCompleteColumns]="columnsNormGrades"
                                [autoCompleteColumnsToHide]="columnsToHideNormGrades" [autoCompleteField]="'normGrades'"
                                [columnsWidthPerc]="[100]" [multiSelection]="true"
                                (onAutocompleteInputChange)="onAutocompleteInputChange($event, c, x)"
                                (onAutocompleteSelectRows)="onAutocompleteSelectRows($event,c,x)"
                                (onAutocompleteRemoveElement)="onAutocompleteRemoveElement($event, c,x)"
                                [autoCompletePosition]="'sticky'" [readOnly]="false"
                                [chipsContainerViewHeight]="4"></teiasoft-input>
                            <i class="fas fa-times-circle undo-icon" *ngIf="valueChanged" (click)="undoChange(c,x)"></i>
                            <!-- <i class="fas fa-check-circle confirm-icon mr-5" *ngIf="valueChanged"
                            (click)="onConfirmNormGradesChangeClick(c,x)"></i> -->
                        </div>

                        <!-- gradeCustomerAnalysisLimitation -->
                        <div *ngIf="col.colName!.toLowerCase() == 'gradecustomeranalysislimitation'"
                            class="cnt-limitation">
                            <teiasoft-confirmable-input (navigationKey)="handleKeydown($event, c, x)" style="width:80%"
                                [type]="getIsCustomLimitation(c,x, col.colName!) ? 'input' : 'select'"
                                [applyChange]="applyChange" [options]="analysisLimitationOptionList"
                                [value]="getIsCustomLimitation(c,x, col.colName!) ? getLimitationValue(c,x) : col.colValue![c]"
                                (confirmChange)="onSelected($event, c, x, col.colType!, col.colName!)"
                                (onValueChanged)="onValueChanged($event)" [customUndoFunction]="onLimitationsUndo(c,x)"
                                [maxLength]="200">
                            </teiasoft-confirmable-input>
                            <!--  <teiasoft-confirmable-input (navigationKey)="handleKeydown($event, c, x)"
                            [hidden]="getIsCustomLimitation(c,x, col.colName!)" [type]="'select'"
                            [options]="analysisLimitationOptionList"
                            [value]="col.colValue![c]"
                            (confirmChange)="onSelected($event, c, x, col.colType!, col.colName!)"
                            (onValueChanged)="onValueChanged($event)"
                            [customUndoFunction]="onLimitationsUndo(c,x)"
                            [originalLimitation]="col.colValue![c]">
                        </teiasoft-confirmable-input>

                        <teiasoft-confirmable-input (navigationKey)="handleKeydown($event, c, x)" style="width:80%"
                            [hidden]="!getIsCustomLimitation(c,x, col.colName!)"
                            [type]="'input'"
                            [value]="getLimitationValue(c,x)" (confirmChange)="onFocusOut($event, c, x, col.colName!)"
                            (onValueChanged)="onValueChanged($event)"
                            [customUndoFunction]="onLimitationsUndo(c,x)"
                            [originalLimitation]="getLimitationValue(c,x)">
                        </teiasoft-confirmable-input> -->

                            <div class="chk-cnt">
                                <i *ngIf="!getIsCustomLimitation(c,x, col.colName!) && thisRowHasNormgrades(c,x)"
                                    class="fal fa-square chk-limitation"
                                    (click)="onCheckLimitation(c,x, col.colName!)"></i>
                                <i *ngIf="getIsCustomLimitation(c,x, col.colName!) && thisRowHasNormgrades(c,x)"
                                    class="fas fa-check-square chk-limitation"
                                    (click)="onCheckLimitation(c,x, col.colName!)"></i>
                                <i *ngIf="!thisRowHasNormgrades(c,x)" class="fal fa-square chk-disabled"></i>
                                <span class="ml-5"
                                    [ngClass]="{'span-disabled' : !thisRowHasNormgrades(c,x)}">Custom</span>
                            </div>
                        </div>

                        <!-- gradeCustomerOtherLimitation -->
                        <div *ngIf="col.colType == 'select' && col.colName!.toLowerCase() == 'gradecustomerotherlimitation'"
                            class="cnt-limitation">
                            <teiasoft-confirmable-input (navigationKey)="handleKeydown($event, c, x)" style="width:80%"
                                [type]="getIsCustomLimitation(c,x, col.colName!) ? 'input' : 'select'"
                                [applyChange]="applyChange" [options]="otherLimitationOptionList"
                                [value]="getIsCustomLimitation(c,x, col.colName!) ? getLimitationValue(c,x) : col.colValue![c]"
                                (confirmChange)="onSelected($event, c, x, col.colType!, col.colName!)"
                                (onValueChanged)="onValueChanged($event)" [customUndoFunction]="onLimitationsUndo(c,x)"
                                [maxLength]="200">
                            </teiasoft-confirmable-input>
                            <!--                         <teiasoft-confirmable-input (navigationKey)="handleKeydown($event, c, x)"
                            *ngIf="!getIsCustomLimitation(c,x, col.colName!)" [type]="'select'"
                            [options]="otherLimitationOptionList"
                            [value]="col.colValue![c]"
                            (confirmChange)="onSelected($event, c, x, col.colType!, col.colName!)"
                            (onValueChanged)="onValueChanged($event)"
                            [originalLimitation]="col.colValue![c]">
                        </teiasoft-confirmable-input>

                        <teiasoft-confirmable-input (navigationKey)="handleKeydown($event, c, x)" style="width:80%"
                            *ngIf="getIsCustomLimitation(c,x, col.colName!)"
                            [type]="'input'" [value]="getLimitationValue(c,x)" (confirmChange)="onFocusOut($event, c, x, col.colName!)"
                            (onValueChanged)="onValueChanged($event)"
                            [originalLimitation]="getLimitationValue(c,x)">
                        </teiasoft-confirmable-input> -->

                            <div class="chk-cnt">
                                <i *ngIf="!getIsCustomLimitation(c,x, col.colName!) && thisRowHasNormgrades(c,x)"
                                    class="fal fa-square chk-limitation"
                                    (click)="onCheckLimitation(c,x, col.colName!)"></i>
                                <i *ngIf="getIsCustomLimitation(c,x, col.colName!) && thisRowHasNormgrades(c,x)"
                                    class="fas fa-check-square chk-limitation"
                                    (click)="onCheckLimitation(c,x, col.colName!)"></i>
                                <i *ngIf="!thisRowHasNormgrades(c,x)" class="fal fa-square chk-disabled"></i>
                                <span class="ml-5"
                                    [ngClass]="{'span-disabled' : !thisRowHasNormgrades(c,x)}">Custom</span>
                            </div>
                        </div>

                        <!-- rawMaterialCode style="margin-top: -2.4vh;width: 96%;margin-left: 2%;"-->
                        <div class="confirm-container"
                            *ngIf="col.colType == 'object' && col.colName!.toLowerCase() == 'rawmaterialgrade'"
                            (keydown)="onConfirmKeyDown($event,c,x,col.colName!)" [tabindex]="c">
                            <teiasoft-input [type]="'text'" [value]="getObjectValue(col.colName!, val)"
                                [showCreate]="false" [autoComplete]="true"
                                [autoCompleteDataset]="rawMaterialGradeDataset"
                                [autoCompleteColumns]="columnsRawMaterialGrades"
                                [autoCompleteColumnsToHide]="columnsToHideRawMaterialGrades"
                                [autoCompleteField]="'rawMaterialGrades'" [columnsWidthPerc]="[100]"
                                (onAutocompleteSelect)="onAutocompleteSelect($event,c,x)"
                                (onAutocompleteInputChange)="onAutocompleteInputChange($event, c, x)"
                                [autoCompletePosition]="'sticky'" [readOnly]="false"
                                [preserveFocusOnAutocompleteSelection]="true"></teiasoft-input>
                            <div class="confirm-icons">
                                <i class="fas fa-times-circle undo-icon" *ngIf="valueChanged"
                                    (click)="undoChange(c,x)"></i>
                                <!-- <i class="fas fa-check-circle confirm-icon" *ngIf="valueChanged"
                                (click)="onConfirmAutocompleteChangeClick($event, c,x,col.colName!)"></i> -->
                            </div>
                        </div>


                        <!-- quantityUoms -->
                        <teiasoft-confirmable-input (navigationKey)="handleKeydown($event, c, x)"
                            *ngIf="col.colType == 'select' && col.colName!.toLowerCase() == 'quantityuom'"
                            [type]="'select'" [options]="quantityUomsList" [value]="col.colValue![c]"
                            [applyChange]="applyChange"
                            (confirmChange)="onSelected($event, c, x, col.colType!, col.colName!)"
                            (onValueChanged)="onValueChanged($event)">
                        </teiasoft-confirmable-input>

                        <!-- odUoms -->
                        <!-- <teiasoft-confirmable-input (navigationKey)="handleKeydown($event, c, x)"
                        *ngIf="col.colType == 'select' && col.colName!.toLowerCase() == 'oduom'"
                        [type]="'select'" [options]="odUomsList" [value]="col.colValue![c]" [applyChange]="applyChange"
                        (confirmChange)="onSelected($event, c, x, col.colType!, col.colName!)"
                        (onValueChanged)="onValueChanged($event)">
                    </teiasoft-confirmable-input> -->

                        <!-- odToleranceUoms -->
                        <teiasoft-confirmable-input (navigationKey)="handleKeydown($event, c, x)"
                            *ngIf="col.colType == 'select' && col.colName!.toLowerCase() == 'odtoleranceuom'"
                            [type]="'select'" [options]="toleranceUomsList" [value]="col.colValue![c]"
                            [applyChange]="applyChange"
                            (confirmChange)="onSelected($event, c, x, col.colType!, col.colName!)"
                            (onValueChanged)="onValueChanged($event)">
                        </teiasoft-confirmable-input>

                        <!-- idUoms -->
                        <!-- <teiasoft-confirmable-input (navigationKey)="handleKeydown($event, c, x)"
                        *ngIf="col.colType == 'select' && col.colName!.toLowerCase() == 'iduom'"
                        [type]="'select'" [options]="idUomsList" [value]="col.colValue![c]" [applyChange]="applyChange"
                        (confirmChange)="onSelected($event, c, x, col.colType!, col.colName!)"
                        (onValueChanged)="onValueChanged($event)">
                    </teiasoft-confirmable-input> -->

                        <!-- idToleranceUoms -->
                        <teiasoft-confirmable-input (navigationKey)="handleKeydown($event, c, x)"
                            *ngIf="col.colType == 'select' && col.colName!.toLowerCase() == 'idtoleranceuom'"
                            [type]="'select'" [options]="toleranceUomsList" [value]="col.colValue![c]"
                            [applyChange]="applyChange"
                            (confirmChange)="onSelected($event, c, x, col.colType!, col.colName!)"
                            (onValueChanged)="onValueChanged($event)">
                        </teiasoft-confirmable-input>

                        <!-- wtUoms -->
                        <!-- <teiasoft-confirmable-input (navigationKey)="handleKeydown($event, c, x)"
                        *ngIf="col.colType == 'select' && col.colName!.toLowerCase() == 'wtuom'"
                        [type]="'select'" [options]="wtUomsList" [value]="col.colValue![c]" [applyChange]="applyChange"
                        (confirmChange)="onSelected($event, c, x, col.colType!, col.colName!)"
                        (onValueChanged)="onValueChanged($event)">
                    </teiasoft-confirmable-input> -->

                        <!-- wtToleranceUoms -->
                        <teiasoft-confirmable-input (navigationKey)="handleKeydown($event, c, x)"
                            *ngIf="col.colType == 'select' && col.colName!.toLowerCase() == 'wttoleranceuom'"
                            [type]="'select'" [options]="toleranceUomsList" [value]="col.colValue![c]"
                            [applyChange]="applyChange"
                            (confirmChange)="onSelected($event, c, x, col.colType!, col.colName!)"
                            (onValueChanged)="onValueChanged($event)">
                        </teiasoft-confirmable-input>

                        <!-- lengthUoms -->
                        <teiasoft-confirmable-input (navigationKey)="handleKeydown($event, c, x)"
                            *ngIf="col.colType == 'select' && col.colName!.toLowerCase() == 'lengthuom'"
                            [type]="'select'" [options]="lengthUomsList" [value]="col.colValue![c]"
                            [applyChange]="applyChange"
                            (confirmChange)="onSelected($event, c, x, col.colType!, col.colName!)"
                            (onValueChanged)="onValueChanged($event)">
                        </teiasoft-confirmable-input>

                        <!-- totalWeightUoms -->
                        <teiasoft-confirmable-input (navigationKey)="handleKeydown($event, c, x)"
                            *ngIf="col.colType == 'select' && col.colName!.toLowerCase() == 'totalweightuom'"
                            [type]="'select'" [options]="totalWeightUomsList" [value]="col.colValue![c]"
                            [applyChange]="applyChange"
                            (confirmChange)="onSelected($event, c, x, col.colType!, col.colName!)"
                            (onValueChanged)="onValueChanged($event)">
                        </teiasoft-confirmable-input>

                        <!-- Marketing Route -->
                        <teiasoft-confirmable-input (navigationKey)="handleKeydown($event, c, x)"
                            *ngIf="col.colType == 'select' && col.colName!.toLowerCase() == 'marketingroute'"
                            [type]="'select'" [options]="marketingRouteOptionList" [value]="col.colValue![c]"
                            [applyChange]="applyChange"
                            (confirmChange)="onSelected($event, c, x, col.colType!, col.colName!)"
                            (onValueChanged)="onValueChanged($event)">
                        </teiasoft-confirmable-input>

                        <!-- SMS -->
                        <teiasoft-confirmable-input (navigationKey)="handleKeydown($event, c, x)"
                            *ngIf="col.colType == 'select' && col.colName!.toLowerCase() == 'sms'" [type]="'select'"
                            [options]="smsOptionList" [value]="col.colValue![c]" [applyChange]="applyChange"
                            (confirmChange)="onSelected($event, c, x, col.colType!, col.colName!)"
                            (onValueChanged)="onValueChanged($event)">
                        </teiasoft-confirmable-input>

                        <!-- typeOfTolerance -->
                        <teiasoft-confirmable-input (navigationKey)="handleKeydown($event, c, x)"
                            *ngIf="col.colType == 'select' && col.colName!.toLowerCase() == 'typeoftolerance'"
                            [type]="'select'" [options]="typeOfToleranceOptionList" [value]="col.colValue![c]"
                            [applyChange]="applyChange"
                            (confirmChange)="onSelected($event, c, x, col.colType!, col.colName!)"
                            (onValueChanged)="onValueChanged($event)">
                        </teiasoft-confirmable-input>


                        <!-- tubeExecution -->
                        <teiasoft-confirmable-input (navigationKey)="handleKeydown($event, c, x)"
                            *ngIf="col.colType == 'select' && col.colName!.toLowerCase() == 'tubeexecution'"
                            [type]="'select'" [options]="tubeExecutionOptionList" [value]="col.colValue![c]"
                            [applyChange]="applyChange"
                            (confirmChange)="onSelected($event, c, x, col.colType!, col.colName!)"
                            (onValueChanged)="onValueChanged($event)">
                        </teiasoft-confirmable-input>

                        <!-- MarketFamily -->
                        <teiasoft-confirmable-input (navigationKey)="handleKeydown($event, c, x)"
                            *ngIf="col.colType == 'select' && col.colName!.toLowerCase() == 'marketfamily'"
                            [type]="'select'" [options]="marketFamilyOptionList" [value]="col.colValue![c]"
                            [applyChange]="applyChange"
                            (confirmChange)="onSelected($event, c, x, col.colType!, col.colName!)"
                            (onValueChanged)="onValueChanged($event)">
                        </teiasoft-confirmable-input>


                        <!-- testCondition -->
                        <teiasoft-confirmable-input (navigationKey)="handleKeydown($event, c, x)"
                            *ngIf="col.colType == 'select' && col.colName!.toLowerCase() == 'testcondition'"
                            [type]="'select'" [options]="testConditionOptionList" [value]="col.colValue![c]"
                            [applyChange]="applyChange"
                            (confirmChange)="onSelected($event, c, x, col.colType!, col.colName!)"
                            (onValueChanged)="onValueChanged($event)">
                        </teiasoft-confirmable-input>



                        <!-- CTS -->
                        <teiasoft-confirmable-input (navigationKey)="handleKeydown($event, c, x)"
                            *ngIf="col.colName!.toLowerCase() == 'cts'" [type]="'select'" [options]="booleanList"
                            [value]="col.colValue![c]" [applyChange]="applyChange"
                            (confirmChange)="onSelected($event, c, x, col.colType!, col.colName!)"
                            (onValueChanged)="onValueChanged($event)">
                        </teiasoft-confirmable-input>

                        <!-- Delivery Extra Properties -->
                        <teiasoft-confirmable-input (navigationKey)="handleKeydown($event, c, x)"
                            *ngIf="isBooleanColumn(col.colName!)" [type]="'select'" [options]="booleanList"
                            [value]="col.colValue![c]" [applyChange]="applyChange"
                            (confirmChange)="onSelected($event, c, x, col.colType!, col.colName!)"
                            (onValueChanged)="onValueChanged($event)">
                        </teiasoft-confirmable-input>

                        <!-- sql -->
                        <teiasoft-confirmable-input (navigationKey)="handleKeydown($event, c, x)"
                            *ngIf="col.colType == 'select' && col.colName!.toLowerCase() == 'sql'" [type]="'select'"
                            [options]="sqlOptionList" [value]="col.colValue![c]" [applyChange]="applyChange"
                            (confirmChange)="onSelected($event, c, x, col.colType!, col.colName!)"
                            (onValueChanged)="onValueChanged($event)">
                        </teiasoft-confirmable-input>

                        <!-- offerScheme -->
                        <teiasoft-confirmable-input (navigationKey)="handleKeydown($event, c, x)"
                            *ngIf="col.colType == 'select' && col.colName!.toLowerCase() == 'offerscheme'"
                            [type]="'select'" [options]="offerSchemeOptionList" [value]="col.colValue![c]"
                            [applyChange]="applyChange"
                            (confirmChange)="onSelected($event, c, x, col.colType!, col.colName!)"
                            (onValueChanged)="onValueChanged($event)">
                        </teiasoft-confirmable-input>
                        <!-- inspectionType3Dot2 -->
                        <!-- <teiasoft-confirmable-input (navigationKey)="handleKeydown($event, c, x)"
                        *ngIf=" col.colName!.toLowerCase() == 'inspectiontype3dot2'" [type]="'select'"
                        [options]="booleanList" [value]="col.colValue![c]" [applyChange]="applyChange"
                        (confirmChange)="onSelected($event, c, x, col.colType!, col.colName!)"
                        (onValueChanged)="onValueChanged($event)">
                    </teiasoft-confirmable-input> -->

                        <!-- multiple cutting -->
                        <!-- <teiasoft-confirmable-input (navigationKey)="handleKeydown($event, c, x)"
                        *ngIf="col.colName!.toLowerCase() == 'multiplecutting'" [type]="'select'"
                        [options]="booleanList" [value]="col.colValue![c]" [applyChange]="applyChange"
                        (confirmChange)="onSelected($event, c, x, col.colType!, col.colName!)"
                        (onValueChanged)="onValueChanged($event)">
                    </teiasoft-confirmable-input> -->

                        <!-- surfaceType -->
                        <teiasoft-confirmable-input (navigationKey)="handleKeydown($event, c, x)"
                            *ngIf="col.colType == 'select' && col.colName!.toLowerCase() == 'surfacetype'"
                            [type]="'select'" [options]="surfaceTypeOptionList" [value]="col.colValue![c]"
                            [applyChange]="applyChange"
                            (confirmChange)="onSelected($event, c, x, col.colType!, col.colName!)"
                            (onValueChanged)="onValueChanged($event)">
                        </teiasoft-confirmable-input>

                        <!-- mill -->
                        <div class="confirm-container"
                            *ngIf="col.colType == 'object' && col.colName!.toLowerCase() == 'mill'"
                            (keydown)="onConfirmKeyDown($event,c,x,col.colName!)"
                            (focusout)="onConfirmFocusOut($event,c,x,col.colName!)" [tabindex]="c">
                            <teiasoft-input [type]="'text'" [value]="getObjectValue(col.colName!, val)"
                                [showCreate]="false" [autoComplete]="true" [autoCompleteDataset]="millDataset"
                                [autoCompleteColumns]="columnsMill" [autoCompleteColumnsToHide]="columnsToHideMill"
                                [autoCompleteField]="'mill'" [columnsWidthPerc]="[100]"
                                (onAutocompleteSelect)="onAutocompleteSelect($event,c,x)"
                                (onAutocompleteInputChange)="onAutocompleteInputChange($event, c, x)"
                                [autoCompletePosition]="'sticky'" [readOnly]="false"
                                [preserveFocusOnAutocompleteSelection]="true"></teiasoft-input>
                            <div class="confirm-icons">
                                <i class="fas fa-times-circle undo-icon" *ngIf="valueChanged"
                                    (click)="undoChange(c,x)"></i>
                                <!-- <i class="fas fa-check-circle confirm-icon" *ngIf="valueChanged"
                                (click)="onConfirmAutocompleteChangeClick($event, c,x,col.colName!)"></i> -->
                            </div>
                        </div>

                        <!-- material code -->
                        <div class="confirm-container"
                            *ngIf="col.colType == 'object' && col.colName!.toLowerCase() == 'material'"
                            (keydown)="onConfirmKeyDown($event,c,x,col.colName!)"
                            (focusout)="onConfirmFocusOut($event,c,x,col.colName!)" [tabindex]="c">
                            <teiasoft-input [type]="'text'" [value]="getObjectValue(col.colName!, val)"
                                [showCreate]="false" [autoComplete]="true" [autoCompleteDataset]="materialDataset"
                                [autoCompleteColumns]="columnsMaterial"
                                [autoCompleteColumnsToHide]="columnsToHideMaterial" [autoCompleteField]="'materialCode'"
                                [columnsWidthPerc]="[100]" (onAutocompleteSelect)="onAutocompleteSelect($event,c,x)"
                                (onAutocompleteInputChange)="onAutocompleteInputChange($event, c, x)"
                                [allowSingleSelectionClear]="true"
                                (onAutocompleteRemoveElement)="onAutocompleteRemoveElement($event, c, x)"
                                [autoCompletePosition]="'sticky'" [readOnly]="false"
                                [preserveFocusOnAutocompleteSelection]="true"></teiasoft-input>
                            <div class="confirm-icons">
                                <i class="fas fa-times-circle undo-icon" *ngIf="valueChanged"
                                    (click)="undoChange(c,x)"></i>
                            </div>
                        </div>


                        <!-- endscondition -->
                        <teiasoft-confirmable-input (navigationKey)="handleKeydown($event, c, x)"
                            *ngIf="col.colType == 'select' && col.colName!.toLowerCase() == 'endscondition'"
                            [type]="'select'" [options]="endsConditionOptionList" [value]="col.colValue![c]"
                            [applyChange]="applyChange"
                            (confirmChange)="onSelected($event, c, x, col.colType!, col.colName!)"
                            (onValueChanged)="onValueChanged($event)">
                        </teiasoft-confirmable-input>

                        <!-- lengthtype -->
                        <teiasoft-confirmable-input (navigationKey)="handleKeydown($event, c, x)"
                            *ngIf="col.colType == 'select' && col.colName!.toLowerCase() == 'lengthtype'"
                            [type]="'select'" [options]="lengthTypeOptionList" [value]="col.colValue![c]"
                            [applyChange]="applyChange"
                            (confirmChange)="onSelected($event, c, x, col.colType!, col.colName!)"
                            (onValueChanged)="onValueChanged($event)">
                        </teiasoft-confirmable-input>

                        <!-- optionDate -->
                        <!-- <teiasoft-confirmable-input (navigationKey)="handleKeydown($event, c, x)" *ngIf="col.colType == 'date' && col.colName!.toLowerCase() == 'optiondate'"
                            [type]="'date'" [value]="getValue(val, c, col.colName!)" class="ts-option-row"
                            (confirmChange)="onChangeOptionDate($event,c, x, col.colName!)"
                            (onValueChanged)="onValueChanged($event)">
                        </teiasoft-confirmable-input> -->

                        <!-- customDeliveryDate  -->
                        <div class="confirm-container"
                            *ngIf="col.colType == 'date' && col.colName!.toLowerCase() == 'customerdeliverydate'"
                            (keydown)="onConfirmKeyDown($event,c,x,col.colName!)"
                            (focusout)="onConfirmFocusOut($event,c,x,col.colName!)" [tabindex]="c">
                            <teiasoft-datetime [value]="getEditDateValue(val)" [noMargin]="true" [size]="'s'"
                                [type]="'date'" [isRequired]="true" [disabled]="false" [isMobile]="false"
                                (onChange)="onChangeCustomDeliveryDate($event,c,x,col.colName!)"
                                [dateFormat]="globals!.dateFormat!"></teiasoft-datetime>

                            <div class="confirm-icons">
                                <i class="fas fa-eraser undo-icon" *ngIf="!valueChanged && hasDateValue(val)"
                                    (click)="clearDateValue($event, c, x, col.colName!)"></i>
                                <i class="fas fa-times-circle undo-icon" *ngIf="valueChanged"
                                    (click)="undoChange(c,x)"></i>
                                <!-- <i class="fas fa-check-circle confirm-icon" *ngIf="valueChanged"
                            (click)="onConfirmAutocompleteChangeClick($event, c,x,col.colName!)"></i> -->
                            </div>
                        </div>

                        <!-- <teiasoft-confirmable-input (navigationKey)="handleKeydown($event, c, x)"
                        *ngIf=" col.colType == 'date' && col.colName!.toLowerCase() == 'customerdeliverydate'"
                        [type]="'date'" [value]="getValue(val, c, col.colName!)" class="ts-option-row"
                        [applyChange]="applyChange"
                        (confirmChange)="onChangeCustomDeliveryDate($event,c, x, col.colName!)"
                        (onValueChanged)="onValueChanged($event)">
                    </teiasoft-confirmable-input> -->

                        <!-- WTODID/NPS BUTTONS -->
                        <div class="confirm-container" *ngIf="col.colName!.toLowerCase() == 'npsschedule'"
                            (keydown)="onConfirmKeyDown($event,c,x,col.colName!)" tabindex="0">
                            <input value="{{getObjectValue(col.colName!, val)}}"
                                (mousedown)="onMouseDown($event, x, col.colName!)" class="edit-input" readonly>
                            <div class="confirm-icons">
                                <i class="fas fa-times-circle undo-icon" *ngIf="valueChanged"
                                    (click)="undoChangeNps($event, c,x)"></i>
                            </div>
                        </div>

                    </ng-container>

                </div>
            </div>
        </div>
    </div>
    <!-- INFO CONTAINER -->
    <div class="cnt-info">
        <span class="bold" style="font-size: 2vh;"><i class="fal fa-clipboard-list mr-5"></i>{{'commons.logsActivity' |
            translate}}</span>
        <div *ngIf="cellsInError.length + cellsXlxsInError.length > 0" class="cnt-row-log">
            <i class="fal fa-times-circle mr-5 span-error"></i>
            <span class="span-error">
                <span>{{'errors.cells' | translate}} </span>{{countErrors()}}</span>
        </div>
        <!-- <p *ngIf="mapSelected && mapSelected.length > 0">{{mapSelected.length}} - {{mapSelected[0].inEdit}}</p> -->
    </div>
</div>

<!-- MODAL SELECT NPS -->
<app-modal-select-nps *ngIf="showSelectNps" [dataSet]="dataSetNps" [modalTitle]="'enquiryBook.selectNps' | translate"
    [columns]="columnsNps" [columnsToHide]="columnsToHideNps" [selectedRow]="selectedNpsRow"
    [columnsToFilter]="columnsToFilterNps" (onConfirmModalNps)="onConfirmModalNps($event)" [showDeleteSelection]="true"
    (onCloseModalNps)="onCloseModalNps($event)" (deleteSelection)="onDeleteNpsSelection()"></app-modal-select-nps>


<!-- MODAL FOR APPLY/DISCARD/CANCEL VALUE -->
<modal-discard *ngIf="showModalDiscardApply" (onModalButtonsClick)="onModalButtonsClick($event)"></modal-discard>

<!-- MODAL GRID SETTINGS -->
<teiasoft-grid-settings *ngIf="showSettingsDialog" [gridConfiguration]="gridConfiguration"
    (onClose)="onCloseSettings($event)" (onApply)="onApplySettings($event)" [disableSortingCriteria]="true"
    [disableHideFeature]="true" [disableFreezeFeature]="false"></teiasoft-grid-settings>
